import { createTheme } from "@material-ui/core/styles";

// A custom theme for this app
const theme = createTheme({});

export default theme;
